import { createReducer } from '@reduxjs/toolkit';

import {
  resetOrderedPartsFilter,
  setOrderedPartsFilter
} from '../../../actions/coilovers/orderedParts/orderedPartsFilter';
import DEFAULT_PAGINATION_SIZE from '../../../constants/general';

const initialState = {
  page: 1,
  size: DEFAULT_PAGINATION_SIZE,
  order: undefined,
  orderDateFrom: undefined,
  orderDateTo: undefined,
  partStatus: undefined,
  orderedType: undefined,
  query: undefined
};

const orderedPartsFilterReducer = createReducer(initialState, {
  [setOrderedPartsFilter]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [resetOrderedPartsFilter]: () => initialState
});

export default orderedPartsFilterReducer;
